import Swal from "sweetalert2/dist/sweetalert2.js";
import { SHA256, enc, PBKDF2} from 'crypto-js';

export const libTools = {
    method: {
        swalError(prmConfirmButtonText, prmText){
            Swal.fire({
                icon: "error", buttonsStyling: false, customClass: { confirmButton: "btn fw-bold btn-light-danger", },
                text: prmText,
                confirmButtonText: prmConfirmButtonText,
            }).then(function () {
                //
            });
        },

        swalSuccess(prmConfirmButtonText, prmText){
            Swal.fire({
                icon: "success", buttonsStyling: false, customClass: { confirmButton: "btn fw-bold btn-light-danger", },
                text: prmText,
                confirmButtonText: prmConfirmButtonText,
            }).then(function () {
                //
            });
        },

        getTournamentCountDownResult(prmStartDate, prmFinishDate) {
            const vvNow = new Date();
            const objRv = {
                type: "None",
                label: "Turnuva Bitti",
                coundownresult: this.getCountDown(vvNow, vvNow),
            };
            if (prmStartDate.getTime()> vvNow.getTime()) {
                objRv.type = "StartDate";
                objRv.label = "Başlangıca Kalan Süre";
                objRv.coundownresult = this.getCountDown(prmStartDate, vvNow);
            } else if (prmFinishDate.getTime()> vvNow.getTime()) {
                objRv.type = "FinishDate";
                objRv.label = "Bitişe Kalan Süre";
                objRv.coundownresult = this.getCountDown(prmFinishDate, vvNow);
            }
            return objRv;

        },

        getCountDown(prmDateA, prmDateB) {
            const distance = prmDateA.getTime() - prmDateB.getTime();
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if (days>0) {
                return days + " gün " + this.getzeroPad(hours,2) + ":" + this.getzeroPad(minutes, 2) + ":" + this.getzeroPad(seconds, 2);
            } else {
                return this.getzeroPad(hours,2) + ":" + this.getzeroPad(minutes, 2) + ":" + this.getzeroPad(seconds, 2);
            }
        },

        getHashedPass(prmValue) {
            const rv = PBKDF2(prmValue, process.env.VUE_APP_PASSWORD_SALT, { keySize: 8, iterations: 1000  }).toString(enc.Hex);
            //console.log("getHashedPass "+process.env.VUE_APP_PASSWORD_SALT+" "+prmValue+" rv:  "+rv);
            return rv;
        },

        getLogoMain(prmType) {
            let rv = "media/logos/custom/"+process.env.VUE_APP_CUST_MAINLOGO_DARK+".png";
            if (prmType==="light") {
                rv = "media/logos/custom/"+process.env.VUE_APP_CUST_MAINLOGO_WHITE+".png";
            }
            //console.log("getLogoMain "+prmType+" rv:  "+rv);
            return rv;
        },

        setLogoMain(prmImgId) {
            const vvThemeName = this.getThemeName();
            const vvLogoPath = this.getLogoMain(vvThemeName);
            console.log("setLogoMain prmImgId: "+prmImgId+" vvThemeName: "+vvThemeName+" vvLogoPath: "+vvLogoPath);
            (document.getElementById(prmImgId) as HTMLElement).setAttribute("src", ""+vvLogoPath);
        },

        getLogoFavIcon() {
            const rv = window.location.protocol+"//"+ window.location.host+"/"+"media/logos/custom/"+process.env.VUE_APP_CUST_MAINLOGO_FAVICON;
            //console.log("getLogoFavIcon  rv:  "+rv);
            return rv;
        },

        getPageTitle() {
            const rv = ""+process.env.VUE_APP_PAGE_TITLE;
            //console.log("getPageTitle  rv:  "+rv);
            return rv;
        },

        hasTurkishChar(prmText) {
            if (
                prmText.includes("Ü") || prmText.includes("ü") ||
                prmText.includes("Ğ") || prmText.includes("ğ") ||
                prmText.includes("İ") || prmText.includes("ı") ||
                prmText.includes("Ş") || prmText.includes("ş") ||
                prmText.includes("Ö") || prmText.includes("ö") ||
                prmText.includes("Ç") || prmText.includes("ç")
            ) {
                return true;
            }

            return false;
        },

        localeStA(prmValue, prmDigit) {
            return Number(prmValue).toLocaleString(undefined, { minimumFractionDigits: prmDigit,  maximumFractionDigits: prmDigit})
        },

        getCurrentSign(prmCur) {
            if (prmCur === "TRY") return "₺";
            if (prmCur === "USD") return "$";
            return "₺";
        },

        getTransferProcessTypeName(prmProcessType) {
            if (prmProcessType==="MANUEL") return "MANUEL";
            if (prmProcessType==="GAME") return "İŞLEM";
            if (prmProcessType==="BONUS") return "BONUS";
            if (prmProcessType==="DEPOSIT") return "YATIRIM";
            if (prmProcessType==="WITHDRAW") return "ÇEKİM";

            if (prmProcessType==="TOURNAMENT") return "TURNUVA";
            if (prmProcessType==="JACKPOT") return "JACKPOT";
            if (prmProcessType==="WITHDRAWCANCEL") return "ÇEKİM İPTALİ";
            if (prmProcessType==="FIXES") return "FİNANSAL DÜZENLEME";
            if (prmProcessType==="BONUSCANCEL") return "BONUS İPTALİ";

            if (prmProcessType==="TOURNAMENTJOIN") return "TURNUVA KATILIM";
            if (prmProcessType==="TOURNAMENTPRIZE") return "TURNUVA ÖDÜL";
            if (prmProcessType==="TOURNAMENTGAME") return "TURNUVA İŞLEM";

            if (prmProcessType==="SENDFRIEND") return "ARKADAŞINA GÖNDER";

            return "";
        },

        getTransferTypName(prmProcessType) {
            if (prmProcessType==="IN") return "ARTI";
            if (prmProcessType==="OUT") return "EKSİ";
            return "";
        },

        getDayOfWeek(prmDate) {
            let vvDayOfWeek = prmDate.getDay()	;
            if (vvDayOfWeek===0) vvDayOfWeek = 7;
            return vvDayOfWeek;
        },

        getzeroPad (prmNumber, prmCount) {
           return String(prmNumber).padStart(prmCount, '0');
        } ,
        getThemeName() {
            const vvThemeName = document.documentElement.getAttribute("data-theme");
            return vvThemeName;
        },

    }
}

class Lib_Tools {

}

export default Lib_Tools;